import React, { useEffect } from 'react';
import styles from './MultiSelectDropdown.module.css';
import caret from "./assets/caret.svg";

export default function MultiSelectDropdown({ buttonLabel, options, name, handleCheckboxChange, isActive, toggleDropdown, checkedOptions }) {
    // close dropdown if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            // check if the event target has a parent with the class 'MultiSelectDropdown'
            const div = event.target.closest('div[class*=MultiSelectDropdown]');
            if (div === null) {
                toggleDropdown(null);
            }
        };
    
        const body = document.querySelector('body');
        // add event listener if it does not exist
        if (!body.hasAttribute('listenerOnClick')) {
            body.setAttribute('listenerOnClick', 'true');
            body.addEventListener('click', handleClickOutside);
        }
    
        return () => {
            // cleanup the event listener on component unmount if it was added
            if (body.hasAttribute('listenerOnClick')) {
                body.removeAttribute('listenerOnClick');
                body.removeEventListener('click', handleClickOutside);
            }
        };
    }, [toggleDropdown]);
    

    let dropdownOptions = options.map(option => (
        <li key={option.value} >
            
                {option.value !== "all" ? (
                    <>
                    <label htmlFor={`${name}-${option.value}-filter`}>
                        <input
                            id={`${name}-${option.value}-filter`}
                            type="checkbox"
                            name={name}
                            value={option.value}
                            checked={checkedOptions.has(String(option.value))}
                            onChange={(e) => handleCheckboxChange(e, option.label)}
                            aria-labelledby={`${option.label} checkbox filter option`}
                        /> {option.label}
                        </label>
                    </>
                ) : (
                    <button 
                        type="button"
                        name={name}
                        value={option.value}
                        onClick={(e) => handleCheckboxChange(e, option.label)}
                        aria-labelledby={`${option.label} ${option.name} button`}
                    >
                        {option.label}
                    </button>
                )}
            
        </li>
    ));
    

    return (
        <div className={`${styles.container} ${isActive ? styles.active : ''}`}>
            <button className={styles.dropbtn} onClick={() => toggleDropdown(name)} aria-haspopup="true" aria-expanded={isActive}>{buttonLabel} <img src={caret} alt="caret" /></button>
            <ul className={isActive ? styles.dropdownContent : styles.hidden} aria-label={buttonLabel}>
                {dropdownOptions}
            </ul>
        </div>
    );
}
